<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->
<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<!-- ══════════════════════════════════════════════════════════════
Buscador + Tabla
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill placeholder="Nombre o correo…" (search)="onSearch($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="usuarios"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadAll())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-flat-button color="primary" (click)="openCreate()">
        <mat-icon>person_add</mat-icon> Nuevo Usuario
      </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="exportExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando usuarios...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (u of dataSource.filteredData; track $index) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(u)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(u)" (change)="sel.toggle(u)" matTooltip="Seleccionar"></mat-checkbox>
            <div class="avatar">{{ getInitials(u.name) }}</div>
            <span class="cat-card__title">{{ u.name }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Correo:</span><span class="cat-card__value">{{ contactOf(u) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Rol:</span><span class="cat-card__value">
              @if (getRoleName(u) !== '—') { <span class="role-chip">{{ getRoleName(u) }}</span> } @else { <span class="no-role">Sin rol</span> }
            </span></div>
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button color="primary" matTooltip="Editar" (click)="openEdit(u)"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button color="primary" matTooltip="Ubicaciones y especialidades" (click)="openCustomParams(u)"><mat-icon>tune</mat-icon></button>
            <button mat-icon-button color="accent" matTooltip="Reenviar invitación / Reiniciar contraseña" (click)="resetPassword(u)" [disabled]="loading()"><mat-icon>lock_reset</mat-icon></button>
            <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteUser(u)"><mat-icon>delete</mat-icon></button>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin resultados</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let u">
          <div class="avatar">{{ getInitials(u.name) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let u">
          <span class="user-name">{{ u.name }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Correo</th>
        <td mat-cell *matCellDef="let u">
          <span class="user-email">{{ contactOf(u) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rol</th>
        <td mat-cell *matCellDef="let u">
          @if (getRoleName(u) !== '—') {
            <span class="role-chip">{{ getRoleName(u) }}</span>
          } @else {
            <span class="no-role">Sin rol</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let u">
          <button mat-icon-button color="primary" matTooltip="Editar"
            (click)="openEdit(u)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Ubicaciones y especialidades"
            (click)="openCustomParams(u)">
            <mat-icon>tune</mat-icon>
          </button>
          <button mat-icon-button color="accent" matTooltip="Reenviar invitación / Reiniciar contraseña"
            (click)="resetPassword(u)" [disabled]="loading()">
            <mat-icon>lock_reset</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Eliminar"
            (click)="deleteUser(u)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>person_search</mat-icon>
            <span>No se encontraron usuarios</span>
          </div>
        </td>
      </tr>
    </table>
  </div>


</div>